import './paedml-card.tag'
import './paedml-icon.tag'
import './paedml-icon-modal.tag'
import './paedml-modal-pw.tag'
import './paedml-modal-delete.tag'
import './paedml-modal-activate-user.tag'

<paedml-card-logoninformation>
  <paedml-card config={opts.config} perm={opts.perm} siblings={opts.siblings}>
    <virtual if="{canChangePassword()}">
      <paedml-icon-modal icon="passwort-bearbeiten" target="#{prefix}-pw-modal" title="Kennwort ändern" />
      <paedml-modal-pw prefix="{prefix}-pw" heading={config.contentTitle} selectedrowsfunc={getSelectedRows}
         variant={parent.variant} preset="{config.preset ? config.preset.password : {}}" api={restApi} doredirect={true} 
         indexschulart={parent.indexschulart}/>
    </virtual>

    <virtual if="{parent.variant === 'student' && selectedOneOrMore() && isPermitted('activate')}">
      <paedml-icon-modal icon="fas-unlock-keyhole" target="#{prefix}-run-activate-user-modal" title="Schüler*in(nen) (de)aktivieren" />
      <paedml-modal-activate-user prefix="{prefix}-run-activate-user" heading="Schüler*in(nen) (de)aktivieren" selectedrowsfunc={getSelectedRows}
         variant={parent.variant} opname="Ausführen" api={restApi} deactivatedcol={parent.deactivatedcol} doredirect={true} />
    </virtual>

    <virtual if="{parent.variant === 'student' && canDelete()}">
      <paedml-icon-modal icon="loeschen" target="#{prefix}-delete-modal" title="Schüler*in(nen) löschen" />
      <paedml-modal-delete heading="{config.contentTitle}: Schüler*in(nen) löschen" prefix="{prefix}-delete" 
        variant={parent.variant} selectedrowsfunc={getSelectedRows} api={restApi} doredirect={true} doredirect={true} />
    </virtual>

     <virtual if="{parent.variant === 'teacher' && selectedOneOrMore() && isPermitted('activate')}">
      <paedml-icon-modal icon="fas-unlock-keyhole" target="#{prefix}-run-activate-user-modal" title="Lehrer*in(nen) (de)aktivieren" />
      <paedml-modal-activate-user prefix="{prefix}-run-activate-user" heading="Lehrer*in(nen) (de)aktivieren" selectedrowsfunc={getSelectedRows}
         variant={parent.variant} opname="Ausführen" api={restApi} deactivatedcol={parent.deactivatedcol} doredirect={true} />
    </virtual>

    <virtual if="{parent.variant === 'teacher' && canDelete()}">
      <paedml-icon-modal icon="loeschen" target="#{prefix}-delete-modal" title="Lehrer*in(nen) löschen" />
      <paedml-modal-delete heading="{config.contentTitle}: Lehrer*in(nen) löschen" prefix="{prefix}-delete" 
        variant={parent.variant} selectedrowsfunc={getSelectedRows} api={restApi} doredirect={true} />
    </virtual>
  </paedml-card>
 
 <script>
    this.prefix = opts.prefix
    this.variant = opts.config.custom.variant
    this.deactivatedcol = opts.config.custom.deactivatedcol
    this.indexschulart = opts.config.custom.indexschulart
  </script>

</paedml-card-logoninformation>
